module.exports = __webpack_public_path__ + "img/CH01-020-021.bcc4242f.jpg";